"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("@material-ui/icons");
var react_1 = __importStar(require("react"));
var hoveredIconButtonStyles_1 = require("./hoveredIconButtonStyles");
var TTableColumnMenu_1 = __importDefault(require("./TTableColumnMenu"));
var utils_1 = require("./utils/utils");
var useStyles = styles_1.makeStyles(function () { return ({
    cell: {
        minWidth: 150,
    },
}); });
function TTableHeadCell(props) {
    var col = props.col, multiSort = props.multiSort, draggableProvided = props.draggableProvided, modeStyle = props.modeStyle, changeVisibleColumns = props.changeVisibleColumns, visibleSettings = props.visibleSettings;
    var _a = react_1.useState(null), cellRef = _a[0], setCellRef = _a[1];
    var _b = react_1.useState(false), isHovered = _b[0], setIsHovered = _b[1];
    var cell = useStyles().cell;
    var isWithColumnMenu = visibleSettings.column.isWithColumnMenu;
    var visibilityMenu = isWithColumnMenu && (col.canFilter || !col.blockHide || col.filterValue);
    var setRef = react_1.useCallback(function (el) {
        setCellRef(el);
        draggableProvided && draggableProvided.innerRef(el);
    }, [setCellRef, draggableProvided]);
    var _c = hoveredIconButtonStyles_1.useHoveredIconButtonStyles(), root = _c.root, icon = _c.icon, hovered = _c.hovered, active = _c.active;
    var toggleSort = react_1.useCallback(function (col) { return function () { return col.toggleSortBy(utils_1.nextSortDirection(col.isSortedDesc), multiSort); }; }, [multiSort]);
    return (react_1.default.createElement(core_1.TableCell, __assign({ onMouseEnter: function () { return setIsHovered(true); }, onMouseLeave: function () { return setIsHovered(false); }, className: cell, ref: setRef }, col.getHeaderProps(), (draggableProvided && __assign({}, draggableProvided.draggableProps))),
        react_1.default.createElement(core_1.Grid, { container: true, wrap: "nowrap" },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Tooltip, { title: col.render('Header') },
                    react_1.default.createElement(core_1.Typography, { className: modeStyle, variant: "inherit" }, col.shortHeader))),
            react_1.default.createElement(core_1.Grid, { item: true }, col.canSort ? (react_1.default.createElement(core_1.ButtonBase, { disableRipple: true, className: root + " " + (col.isSorted ? active : '') + " " + (isHovered ? hovered : ''), onClick: toggleSort(col) }, utils_1.sortDirection(col.isSortedDesc) !== 'asc' ? (react_1.default.createElement(icons_1.ExpandMore, { className: icon })) : (react_1.default.createElement(icons_1.ExpandLess, { className: icon })))) : null),
            visibilityMenu && (react_1.default.createElement(TTableColumnMenu_1.default, { col: col, cellRef: cellRef, isHovered: isHovered, changeVisibleColumns: changeVisibleColumns })),
            draggableProvided && (react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.ButtonBase, __assign({}, (draggableProvided && __assign({}, draggableProvided.dragHandleProps)), { disableRipple: true, className: root + " " + (isHovered ? hovered : '') }),
                    react_1.default.createElement(icons_1.OpenWith, { className: icon + " " })))))));
}
exports.default = TTableHeadCell;
